
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer/account/[path]",
      function () {
        return require("private-next-pages/customer/account/[path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer/account/[path]"])
      });
    }
  